<template>
  <v-app-bar
    color="primary"
    density="comfortable"
  >
    <BreadCrumb />

    <div
      id="help"
      title="Help"
    >
      <v-btn
        variant="text"
        @click="$router.push({ name: 'HelpPage' })"
      >
        <span>Help</span>
        <v-icon
          icon="mdi-help-circle"
          size="32"
        />
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue'
export default {
  name: 'NavBar',
  components: {
    BreadCrumb,
  }
}
</script>

<style>
#help {
  margin-left: auto; /* pushes Help to the right */
  display: block;
}
</style>
